import template from './doctor-list.html';
import './doctor-list.scss';

export default angular
  .module('doxy.patient.doctorList', [])
  .component('doctorList', {
    // doctor-list
    template,
    controller: function (pn, activeComponents) {
      Object.assign(this, {
        pn,
        activeComponents,
      });
    },
  }).name;
